import { useState, useEffect } from 'react';

import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import ApplicantCallModal from './ApplicantCallModal';
import { useIsInSelfServeSplitTest } from '../../../../customHooks/useIsInSelfServeSplitTest';
import { FormalOffer } from '../../../myOffers/MyOffers.types';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';

export const ApplicantCallAction = ({
    productType,
    status
}: {
    productType: FormalOffer['product_type'];
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isInSelfServeTest = useIsInSelfServeSplitTest();

    const { branch: selfServeTestBranch } = useSplitTestBranch({
        test: 'de_self_serve_split_test_dec_2025',
        enabled: false,
        suspense: false
    });
    const isInDESelfServeTest = selfServeTestBranch === 'INCLUDE';
    const handleModalClose = () => {
        setIsModalOpen(!isModalOpen);
    };

    const isIwocaPay: boolean = productType === 'iwocapay';

    useEffect(() => {
        if (isInSelfServeTest) {
            tracking.ampli.allSetForNowFundingRequirementMessageShown();
        } else {
            tracking.ampli.giveUsACallFundingRequirementShown();
        }
    }, [isInSelfServeTest]);

    if (isInSelfServeTest || isInDESelfServeTest) {
        return (
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_self_serve_title"
                        defaultMessage="You're all set for now"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_self_serve_caption"
                        defaultMessage="We're wrapping up some final checks and will be in touch soon."
                    />
                }
                action={<></>}
            />
        );
    }

    return (
        <>
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_title"
                        defaultMessage="Give us a quick call"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_caption"
                        defaultMessage="We need to talk to you over the phone."
                    />
                }
                action={
                    <FundingStepActionButton
                        actionMessage={
                            <FormattedMessage
                                id="_.funding_requirements.call_action"
                                defaultMessage="Call Now"
                            />
                        }
                        pendingMessage={
                            <FormattedMessage
                                id="_.funding_requirements.call_action_pending"
                                defaultMessage="Pending"
                            />
                        }
                        status={status === 'PENDING' ? 'REQUIRED' : status}
                        handleFundingStepAction={() => setIsModalOpen(true)}
                        stepName="Applicant call"
                    />
                }
            />

            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <ApplicantCallModal
                    onClose={handleModalClose}
                    isIwocaPay={isIwocaPay}
                />
            </Modal>
        </>
    );
};
